export default "__VITE_ASSET__k8XVty2n__"